export type TaskTypeKeyStatusHelp =
  'unavailable' | 'loading' | 'locked' | 'required' | 'optional';

export type TaskTypeInputSchemaHint = 'enforced' | 'not-enforced';

/** Which status sentence the task-type picker shows under the select. */
export function taskTypeKeyStatusHelp(input: {
  taskTypesUnavailable: boolean;
  isLoading: boolean;
  locksTaskType: boolean;
  required: boolean;
}): TaskTypeKeyStatusHelp {
  if (input.taskTypesUnavailable) return 'unavailable';
  if (input.isLoading) return 'loading';
  if (input.locksTaskType) return 'locked';
  if (input.required) return 'required';
  return 'optional';
}

/**
 * Whether to explain the selected type's input schema, and which explanation.
 * Null when the type has no fields or this step does not create with that schema.
 */
export function taskTypeInputSchemaHint(input: {
  showInputSchemaHint: boolean;
  fieldCount: number;
  enforcesInputSockets: boolean;
}): TaskTypeInputSchemaHint | null {
  if (!input.showInputSchemaHint || input.fieldCount === 0) return null;
  return input.enforcesInputSockets ? 'enforced' : 'not-enforced';
}
